
import React, {useState , useEffect} from 'react';
import "./Temp.css";
import "./Navbar";

export default function Temp({ tempInfo }) {
    const [weatherState, setWeatherState] = useState("");

    const {
        temp,
        humidity,
        pressure,
        weathermood,
        name,
        speed,
        country,
        sunset,
    } = tempInfo;

    useEffect(() =>{
        if(weathermood){
            switch(weathermood){
                case "Clouds": 
                    setWeatherState("wi wi-day-cloudy");
                    break;
                case "Haze": 
                    setWeatherState("wi wi-fog");
                    break;
                case "Clear": 
                    setWeatherState("wi wi-cloud");
                    break;
                case "Sunny": 
                    setWeatherState("wi wi-day-sunny");
                    break;
                case "Rain": 
                    setWeatherState("wi wi-rain");
                    break;
                case "Fog": 
                    setWeatherState("wi wi-fog");
                    break;
                default: 
                    setWeatherState("wi wi-windy");
                    break;
            }
        }
    },[weathermood])

    let sec = sunset;
    let date = new Date(sec*1000);
    let timeStr = `${date.getHours()}:${date.getMinutes()}`;
  return (
  <>
    <article className='widget'>
        <div className='weatherIcon'>
            <i className={`${weatherState}`}></i>
        </div>
        <div className="weatherInfo">
            <div className="temperature">
            <span className='degree'>{temp}&deg;</span>
        </div>
        <div className="description">
            <div className="weatherCondition">{weathermood}</div>
            <div className="place">{name},{country}</div>
        </div>
        </div>
        <div className="date">{new Date().toLocaleString()}</div>
        <div className="extra-temp">
            <div className="temp-info-minmax">
                <div className="two-sided-section">
                    <p><i className={'wi wi-sunset'}></i></p>
                    <p className="extra-info-leftside">{timeStr} <br />Sunset</p>
                </div>
                <div className="two-sided-section">
                    <p><i className={'wi wi-humidity'}></i></p>
                    <p className="extra-info-leftside">{humidity} <br />Humidity</p>
                </div>
                <div className="two-sided-section">
                    <p><i className={'wi wi-rain'}></i></p>
                    <p className="extra-info-leftside">{pressure} <br />Pressure</p>
                </div>
                <div className="two-sided-section">
                    <p><i className={'wi wi-strong-wind'}></i></p>
                    <p className="extra-info-leftside">{speed} <br /> Speed</p>
                </div>
            </div>
        </div>

    </article>
  </>
  )
}
